module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightpage",
    attrs: {
      "id": "d7e6"
    }
  }, [_c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("Copyright © 2007 by Tammy Kraemer and Tyler Kraemer")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("All rights reserved. This book, or parts thereof, may not be reproduced in any form without permission from the publisher; exceptions are made for brief excerpts used in published reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("Published by Adams Business An imprint of Adams Media, an imprint of Simon & Schuster, Inc. 57 Littlefield Street, Avon, MA 02322 www.adamsmedia.com")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("ISBN-10: 1-59869-215-1 • ISBN-13: 978-1-59869-215-0 (paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("ISBN-13: 978-1-44050-102-9 (EPUB)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("Kraemer, Tammy.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("The complete guide to reverse mortgages / Tammy Kraemer and Tyler Kraemer.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("ISBN-13: 978-1-59869-215-0 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("ISBN-13: 978-1-44050-102-9 (EPUB)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("ISBN-10: 1-59869-215-1 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("1. Mortgage loans, Reverse. 2. Home equity conversion. 3. Retirement income. 4. Mortgage loans, Reverse — United States. 5. Home equity conversion — United States. 6. Retirement income — United States. I. Kraemer, Tyler. II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("HG2040.15.K73 2007")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("332.7′22 — dc22 2007015753")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("Printed in Canada.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("J I H G F E D C B A")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e65"
    }
  }, [_vm._v("DISCLAIMER: This book contains the ideas and opinions of its authors. The intent of this book is to provide competent, useful information about the subject matter covered. However, this book is purchased with the understanding that neither the authors nor the publisher are engaged in rendering specific accounting, financial, insurance, investment, legal, tax, or other professional advice and services. If the reader requires such advice and/ or services, a competent professional should be consulted. It should also be noted that the strategies described in this book may not be suitable for every individual, are not guaranteed or warranted to produce any particular results, and that relevant laws vary from state to state. No warranty is made with respect to the accuracy or completeness of the information contained herein. The authors and the publisher specifically disclaim any responsibility for any liability, loss, or risk, personal or otherwise, which is incurred as a consequence, directly or indirectly, of the use and application of any of the contents of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e67"
    }
  }, [_vm._v("This publication is designed to provide accurate and authoritative information with regard to the subject matter covered. It is sold with the understanding that the publisher is not engaged in rendering legal, accounting, or other professional advice. If legal advice or other expert assistance is required, the services of a competent professional person should be sought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e69"
    }
  }, [_vm._v("— From a "), _c('i', [_vm._v("Declaration of Principles")]), _vm._v(" jointly adopted by a Committee of the American Bar Association and a Committee of Publishers and Associations")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e76"
    }
  }, [_c('i', [_vm._v("This book is available at quantity discounts for bulk purchases. For information, please call 1-800-289-0963.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f5784c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Krae_9781440501029_epub_part1.vue
// module id = 66
// module chunks = 0